import { defineLocale } from "../../registry";

const common = defineLocale({
  ru: {
    "common.save": "Сохранить",
    "common.cancel": "Отмена",
    "common.close": "Закрыть",
    "common.reload": "Перезагрузить",
    "common.retry": "Повторить",
    "common.loading": "Загрузка…",
    "common.empty": "Ничего не найдено",
    "common.noPermission": "Недостаточно прав для просмотра этого раздела",
    "common.language": "Язык интерфейса",
    "common.language.ru": "Русский",
    "common.language.en": "English",
    "common.items": "Элементов: {count}",
    "common.traceId": "Идентификатор трассировки: {traceId}",
    "common.error.generic": "Не удалось выполнить действие, повторите",
    "common.error.network": "Нет соединения, повторите",
    "common.error.notFound": "Pick не найден",
    "common.error.rateLimited":
      "Слишком много запросов, повторите через несколько секунд",
    "common.error.writeUnavailable":
      "Сохранение временно недоступно, данные формы сохранены, повторите",
    "common.error.revisionConflict": "Изменено другим пользователем",
    "common.error.refetchFailed":
      "Не удалось обновить данные, показана предыдущая версия",
    "guides.page.title": "Гиды",
    "guides.list.new": "Новый гид",
    "guides.list.import": "Импорт seed",
    "guides.list.search.label": "Поиск по названию",
    "guides.list.search.placeholder": "Название гида",
    "guides.list.search.submit": "Найти",
    "guides.list.filter.status": "Статус",
    "guides.list.filter.city": "Город",
    "guides.list.filter.review": "Требует ревью",
    "guides.list.filter.allStatuses": "Все статусы",
    "guides.list.filter.allCities": "Все города",
    "guides.list.status.draft": "Черновик",
    "guides.list.status.published": "Опубликован",
    "guides.list.status.unpublished": "Снят с публикации",
    "guides.list.summary.guides": "Гиды на ревью",
    "guides.list.summary.places": "Места на ревью",
    "guides.list.summary.unavailable": "Не удалось загрузить сводку stale-мест",
    "guides.list.table.caption": "Список гидов",
    "guides.list.table.cover": "Обложка",
    "guides.list.table.title": "Название",
    "guides.list.table.city": "Город",
    "guides.list.table.status": "Статус",
    "guides.list.table.stale": "Места на ревью",
    "guides.list.stalePlaces": "Места на ревью: {count}",
    "guides.list.table.routes": "Маршруты",
    "guides.list.table.places": "Места",
    "guides.list.table.updated": "Обновлён",
    "guides.list.cover.unavailable": "Нет обложки",
    "guides.list.empty": "Гидов пока нет",
    "guides.list.filteredEmpty": "По этим фильтрам гиды не найдены",
    "guides.list.clearFilters": "Сбросить фильтры",
    "guides.list.loading": "Загружаем гиды",
    "guides.list.error": "Не удалось загрузить гиды",
    "guides.list.permissionChanged": "Ваши права изменились. Обновите страницу",
    "guides.list.retry": "Повторить",
    "guides.list.loadMore": "Загрузить ещё",
    "guides.list.loadingMore": "Загружаем…",
    "guides.list.loadMoreError": "Не удалось загрузить следующую страницу",
    "guides.list.citiesError": "Не удалось загрузить список городов",
    "guides.sidebar.label": "Гиды",
    "guides.sidebar.labelWithOne": "Гиды, {count} место требует ревью",
    "guides.sidebar.labelWithFew": "Гиды, {count} места требуют ревью",
    "guides.sidebar.labelWithMany": "Гиды, {count} мест требуют ревью",
    "guides.editor.action.addItem": "Добавить элемент",
    "guides.editor.action.moveUp": "{item}: переместить элемент {index} выше",
    "guides.editor.action.moveDown": "{item}: переместить элемент {index} ниже",
    "guides.editor.action.remove": "{item}: удалить элемент {index}",
    "guides.editor.action.moveUpShort": "Вверх",
    "guides.editor.action.moveDownShort": "Вниз",
    "guides.editor.action.removeShort": "Удалить",
    "guides.editor.backToGuides": "К списку гидов",
    "guides.editor.untitled": "Новый гид",
    "guides.editor.status.draft": "Черновик",
    "guides.editor.status.published": "Опубликован",
    "guides.editor.status.unpublished": "Снят с публикации",
    "guides.editor.tab.basics": "Основное",
    "guides.editor.tab.sections": "Разделы",
    "guides.editor.tab.places": "Места",
    "guides.editor.tab.itineraries": "Маршруты",
    "guides.editor.tab.photos": "Фото и атрибуция",
    "guides.editor.tab.publishing": "Публикация",
    "guides.editor.tab.pending": "Раздел пока в разработке",
    "guides.editor.tabs.label": "Вкладки редактора гида",
    "guides.editor.navigation.unsaved.title": "Есть несохранённые изменения",
    "guides.editor.navigation.unsaved.body": "Если уйти сейчас, изменения будут потеряны.",
    "guides.editor.navigation.unsaved.stay": "Остаться",
    "guides.editor.navigation.unsaved.leave": "Выйти без сохранения",
    "guides.editor.basics.label": "Основные поля",
    "guides.editor.basics.title": "Название (EN)",
    "guides.editor.basics.city": "Город",
    "guides.editor.basics.cityPlaceholder": "Выберите город",
    "guides.editor.basics.cityLoading": "Загружаем города…",
    "guides.editor.basics.cityError": "Не удалось загрузить список городов",
    "guides.editor.basics.summary": "Краткое описание (EN)",
    "guides.editor.basics.tagline": "Подзаголовок (EN)",
    "guides.editor.createDraft": "Создать черновик",
    "guides.editor.create.success": "Черновик гида создан",
    "guides.editor.save.saving": "Сохранение…",
    "guides.editor.save.saved": "Изменения сохранены",
    "guides.editor.save.notApplied": "Изменение не применено. Перезагрузите гид перед повторной попыткой.",
    "guides.editor.save.refreshFailed": "Сохранено, но не удалось обновить гид. Перезагрузите его.",
    "guides.editor.error.conflict": "Изменено другим пользователем",
    "guides.editor.error.generic": "Не удалось сохранить изменения",
    "guides.editor.error.notFound": "Гид не найден",
    "guides.editor.error.permissionChanged": "Ваши права изменились. Обновите страницу",
    "guides.editor.error.writeUnavailable": "Сохранение временно недоступно. Данные формы сохранены, повторите попытку.",
    "guides.editor.value.empty": "Не указано",
    "guides.editor.place.unresolved": "Место без названия",
    "guides.editor.reference.placeOutside": "Место отсутствует в этом гиде",
    "guides.editor.reference.routeOutside": "Маршрут отсутствует в этом гиде",
    "guides.editor.reference.neighbourhoodOutside": "Район отсутствует в этом гиде",
    "guides.editor.category.culture": "Культура",
    "guides.editor.category.food": "Еда",
    "guides.editor.category.coffee": "Кофе",
    "guides.editor.category.nature_beaches": "Природа и пляжи",
    "guides.editor.category.markets": "Рынки",
    "guides.editor.category.drinks": "Напитки",
    "guides.editor.category.neighbourhoods": "Районы",
    "guides.editor.sections.label": "Разделы гида",
    "guides.editor.sections.factChips": "Краткие факты",
    "guides.editor.sections.factChip.label": "Подпись",
    "guides.editor.sections.factChip.value": "Значение",
    "guides.editor.sections.atAGlance": "В двух словах",
    "guides.editor.sections.categoryTiles": "Категории гида",
    "guides.editor.sections.category": "Категория",
    "guides.editor.sections.tile.title": "Название",
    "guides.editor.sections.tile.caption": "Описание",
    "guides.editor.sections.tilePhotosKeepOrder": "Чтобы не сместить связанные фото, нельзя менять порядок или удалять эти плитки во вкладке Sections.",
    "guides.editor.sections.neighbourhoods": "Районы",
    "guides.editor.sections.neighbourhood.id": "ID района",
    "guides.editor.sections.neighbourhood.name": "Название района",
    "guides.editor.sections.neighbourhood.caption": "Описание района",
    "guides.editor.sections.neighbourhoodPhotoKeepsId": "Чтобы сохранить связанное фото, идентификатор района нельзя изменить или удалить.",
    "guides.editor.sections.shortlist": "Подборка мест",
    "guides.editor.sections.place": "Место",
    "guides.editor.sections.choosePlace": "Выберите место",
    "guides.editor.sections.placeOptional": "Связанное место (необязательно)",
    "guides.editor.sections.noPlace": "Без связанного места",
    "guides.editor.sections.shortlist.tag": "Метка",
    "guides.editor.sections.foodAndDrink": "Еда и напитки",
    "guides.editor.sections.foodAndDrink.enabled": "Включить раздел «Еда и напитки»",
    "guides.editor.sections.foodAndDrink.intro": "Вступление",
    "guides.editor.sections.localExperiences": "Локальные впечатления",
    "guides.editor.sections.experience.title": "Название",
    "guides.editor.sections.experience.caption": "Описание",
    "guides.editor.sections.featuredRoutes": "Рекомендуемые маршруты",
    "guides.editor.sections.route": "Маршрут",
    "guides.editor.sections.chooseRoute": "Выберите маршрут",
    "guides.editor.sections.knowBeforeYouGo": "Перед поездкой",
    "guides.editor.sections.tip.icon": "Значок",
    "guides.editor.sections.tip.title": "Заголовок",
    "guides.editor.sections.tip.text": "Текст",
    "guides.editor.sections.atAGlance.wordCount": "Слов: {count}",
  },
  en: {
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.reload": "Reload",
    "common.retry": "Retry",
    "common.loading": "Loading…",
    "common.empty": "Nothing found",
    "common.noPermission": "You do not have permission to view this section",
    "common.language": "Interface language",
    "common.language.ru": "Русский",
    "common.language.en": "English",
    "common.items": "Items: {count}",
    "common.traceId": "Trace ID: {traceId}",
    "common.error.generic": "Could not complete the action, please retry",
    "common.error.network": "No connection, please retry",
    "common.error.notFound": "Pick not found",
    "common.error.rateLimited": "Too many requests, retry in a few seconds",
    "common.error.writeUnavailable":
      "Saving is temporarily unavailable, form data is kept, please retry",
    "common.error.revisionConflict": "Changed by someone else",
    "common.error.refetchFailed":
      "Could not refresh the data, showing the previous version",
    "guides.page.title": "Guides",
    "guides.list.new": "New guide",
    "guides.list.import": "Import seed",
    "guides.list.search.label": "Search by title",
    "guides.list.search.placeholder": "Guide title",
    "guides.list.search.submit": "Search",
    "guides.list.filter.status": "Status",
    "guides.list.filter.city": "City",
    "guides.list.filter.review": "Requires review",
    "guides.list.filter.allStatuses": "All statuses",
    "guides.list.filter.allCities": "All cities",
    "guides.list.status.draft": "Draft",
    "guides.list.status.published": "Published",
    "guides.list.status.unpublished": "Unpublished",
    "guides.list.summary.guides": "Guides requiring review",
    "guides.list.summary.places": "Places requiring review",
    "guides.list.summary.unavailable": "Could not load the stale places summary",
    "guides.list.table.caption": "Guide list",
    "guides.list.table.cover": "Cover",
    "guides.list.table.title": "Title",
    "guides.list.table.city": "City",
    "guides.list.table.status": "Status",
    "guides.list.table.stale": "Places to review",
    "guides.list.stalePlaces": "Stale places: {count}",
    "guides.list.table.routes": "Routes",
    "guides.list.table.places": "Places",
    "guides.list.table.updated": "Updated",
    "guides.list.cover.unavailable": "No cover",
    "guides.list.empty": "No guides yet",
    "guides.list.filteredEmpty": "No guides match these filters",
    "guides.list.clearFilters": "Clear filters",
    "guides.list.loading": "Loading guides",
    "guides.list.error": "Could not load guides",
    "guides.list.permissionChanged": "Your permissions changed. Refresh the page",
    "guides.list.retry": "Retry",
    "guides.list.loadMore": "Load more",
    "guides.list.loadingMore": "Loading…",
    "guides.list.loadMoreError": "Could not load the next page",
    "guides.list.citiesError": "Could not load the city list",
    "guides.sidebar.label": "Guides",
    "guides.sidebar.labelWithOne": "Guides, {count} place requires review",
    "guides.sidebar.labelWithFew": "Guides, {count} places require review",
    "guides.sidebar.labelWithMany": "Guides, {count} places require review",
    "guides.editor.action.addItem": "Add item",
    "guides.editor.action.moveUp": "{item}: move item {index} up",
    "guides.editor.action.moveDown": "{item}: move item {index} down",
    "guides.editor.action.remove": "{item}: remove item {index}",
    "guides.editor.action.moveUpShort": "Move up",
    "guides.editor.action.moveDownShort": "Move down",
    "guides.editor.action.removeShort": "Remove",
    "guides.editor.backToGuides": "Back to guides",
    "guides.editor.untitled": "Untitled guide",
    "guides.editor.status.draft": "Draft",
    "guides.editor.status.published": "Published",
    "guides.editor.status.unpublished": "Unpublished",
    "guides.editor.tab.basics": "Basics",
    "guides.editor.tab.sections": "Sections",
    "guides.editor.tab.places": "Places",
    "guides.editor.tab.itineraries": "Itineraries",
    "guides.editor.tab.photos": "Photos & attribution",
    "guides.editor.tab.publishing": "Publishing",
    "guides.editor.tab.pending": "This section is coming soon",
    "guides.editor.tabs.label": "Guide editor tabs",
    "guides.editor.navigation.unsaved.title": "Unsaved changes",
    "guides.editor.navigation.unsaved.body": "If you leave now, your changes will be lost.",
    "guides.editor.navigation.unsaved.stay": "Stay",
    "guides.editor.navigation.unsaved.leave": "Leave without saving",
    "guides.editor.basics.label": "Guide basics",
    "guides.editor.basics.title": "Title (English)",
    "guides.editor.basics.city": "City",
    "guides.editor.basics.cityPlaceholder": "Select a city",
    "guides.editor.basics.cityLoading": "Loading cities…",
    "guides.editor.basics.cityError": "Could not load the city list",
    "guides.editor.basics.summary": "Summary (English)",
    "guides.editor.basics.tagline": "Tagline (English)",
    "guides.editor.createDraft": "Create draft",
    "guides.editor.create.success": "Guide draft created",
    "guides.editor.save.saving": "Saving…",
    "guides.editor.save.saved": "Changes saved",
    "guides.editor.save.notApplied": "The change was not applied. Reload the guide before retrying.",
    "guides.editor.save.refreshFailed": "Saved, but the guide could not be refreshed. Reload it.",
    "guides.editor.error.conflict": "Changed by someone else",
    "guides.editor.error.generic": "Could not save changes",
    "guides.editor.error.notFound": "Guide not found",
    "guides.editor.error.permissionChanged": "Your permissions changed. Refresh the page",
    "guides.editor.error.writeUnavailable": "Saving is temporarily unavailable. Form data is kept; please retry.",
    "guides.editor.value.empty": "Not set",
    "guides.editor.place.unresolved": "Unnamed place",
    "guides.editor.reference.placeOutside": "Place is not in this guide",
    "guides.editor.reference.routeOutside": "Route is not in this guide",
    "guides.editor.reference.neighbourhoodOutside": "Neighbourhood is not in this guide",
    "guides.editor.category.culture": "Culture",
    "guides.editor.category.food": "Food",
    "guides.editor.category.coffee": "Coffee",
    "guides.editor.category.nature_beaches": "Nature & beaches",
    "guides.editor.category.markets": "Markets",
    "guides.editor.category.drinks": "Drinks",
    "guides.editor.category.neighbourhoods": "Neighbourhoods",
    "guides.editor.sections.label": "Guide sections",
    "guides.editor.sections.factChips": "Fact chips",
    "guides.editor.sections.factChip.label": "Label",
    "guides.editor.sections.factChip.value": "Value",
    "guides.editor.sections.atAGlance": "At a glance",
    "guides.editor.sections.categoryTiles": "Category tiles",
    "guides.editor.sections.category": "Category",
    "guides.editor.sections.tile.title": "Title",
    "guides.editor.sections.tile.caption": "Caption",
    "guides.editor.sections.tilePhotosKeepOrder": "To keep attached photos with their tiles, reordering or removing these tiles is disabled in Sections.",
    "guides.editor.sections.neighbourhoods": "Neighbourhoods",
    "guides.editor.sections.neighbourhood.id": "Neighbourhood ID",
    "guides.editor.sections.neighbourhood.name": "Neighbourhood name",
    "guides.editor.sections.neighbourhood.caption": "Neighbourhood caption",
    "guides.editor.sections.neighbourhoodPhotoKeepsId": "To keep the attached photo, this neighbourhood ID cannot be changed or removed.",
    "guides.editor.sections.shortlist": "Shortlist",
    "guides.editor.sections.place": "Place",
    "guides.editor.sections.choosePlace": "Choose a place",
    "guides.editor.sections.placeOptional": "Related place (optional)",
    "guides.editor.sections.noPlace": "No related place",
    "guides.editor.sections.shortlist.tag": "Tag",
    "guides.editor.sections.foodAndDrink": "Food & drink",
    "guides.editor.sections.foodAndDrink.enabled": "Enable food & drink section",
    "guides.editor.sections.foodAndDrink.intro": "Intro",
    "guides.editor.sections.localExperiences": "Local experiences",
    "guides.editor.sections.experience.title": "Title",
    "guides.editor.sections.experience.caption": "Caption",
    "guides.editor.sections.featuredRoutes": "Featured routes",
    "guides.editor.sections.route": "Route",
    "guides.editor.sections.chooseRoute": "Choose a route",
    "guides.editor.sections.knowBeforeYouGo": "Know before you go",
    "guides.editor.sections.tip.icon": "Icon",
    "guides.editor.sections.tip.title": "Title",
    "guides.editor.sections.tip.text": "Text",
    "guides.editor.sections.atAGlance.wordCount": "Words: {count}",
  },
});

export default common;
